import { render, staticRenderFns } from "./GeneralSearchResultsExtensionBased.vue?vue&type=template&id=1d1e81e8&"
import script from "./GeneralSearchResultsExtensionBased.vue?vue&type=script&lang=js&"
export * from "./GeneralSearchResultsExtensionBased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports